<template>
  <table>
    <tr>
      <td>{{ i18n.database.table.vehicles.columns.license_plate }}</td>
      <td>{{ model.license_plate }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_brands.singular }}</td>
      <td>{{ model.brand_name }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_models.singular }}</td>
      <td>{{ model.model_name }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_types.singular }}</td>
      <td>{{ model.type ? model.type.name : '-' }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_colors.singular }}</td>
      <td>{{ model.color ? model.color.name : '-' }}</td>
    </tr>

    <tr v-if="model.transmission_type">
      <td>{{ i18n.database.table.vehicle_transmission_types.singular }}</td>
      <td>{{ model.transmission_type.name }}</td>
    </tr>
    <tr v-if="model.fuel_type">
      <td>{{ i18n.database.table.vehicle_fuel_types.singular }}</td>
      <td>{{ model.fuel_type.name }}</td>
    </tr>

    <tr v-for="item in accessories" :key="item.id">
      <td :colspan="isHidingMissingAccessories ? 2 : 1">{{ item.name }}</td>
      <td v-if="!isHidingMissingAccessories">
        <div v-if="item.value">
          <i class="cs-check"></i>
          <span v-if="item.tag == ACCESSORY_TAG.TOW_BAR && model.towing_capacity">({{ model.towing_capacity.restrained
          }}kg)</span>
        </div>

        <i v-else class="cs-close"></i>
      </td>
    </tr>
  </table>
</template>

<script>
import { ACCESSORY_TAG } from "@/models/Accessory";
import { mapGetters } from 'vuex';

export default {
  name: "vehicle-specs-list",
  props: ["model"],
  data() {
    return {
      ACCESSORY_TAG: ACCESSORY_TAG,
    };
  },
  computed: {
    accessories() {
      if (this.isHidingMissingAccessories) {
        return this.model.accessories_filterable.filter(item => item.value);
      }

      return this.model.accessories_filterable;
    },
    isHidingMissingAccessories() {
      return this._contractTemplate && this._contractTemplate.is_hiding_missing_accessories;
    },
    ...mapGetters({
      _contractTemplate: "contractTemplate",
    })
  }
};
</script>
